module.exports = __webpack_public_path__ + "static/media/YM72_0.64fb2e9e.jpg";